import gql from 'graphql-tag';

import client from '../graphqlAPI';

// One archived email with its (redacted) body and SES event history
// (ps-email-archive/CONTRACT.md §5). `email` is null when the id is unknown or
// belongs to the other brand. ps-back logs every call as an `email_viewed` line.
const GET_SENT_EMAIL = gql`
  query getSentEmail($messageId: String!) {
    getSentEmail(messageId: $messageId) {
      isAuth
      error
      email {
        messageId
        sentAt
        recipient
        from
        subject
        kind
        source
        dataClass
        status
        archiveState
        templateId
        html
        text
        redactions
        metadataOnlyReason
        events {
          type
          at
          detail
        }
      }
    }
  }
`;

// Resolves to the SentEmailResult, or null when the request itself failed.
const getSentEmail = async (messageId) => {
  try {
    const result = await client.query({
      query: GET_SENT_EMAIL, variables: { messageId }, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getSentEmail Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getSentEmail : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getSentEmail Error: ${error}`);
    return null;
  }
};

export default getSentEmail;
